import colors from "assets/theme/base/colors";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";
import { useEffect } from "react";

const RoundField = ({ chart, handleChange, dictionary }) => {
	const MAX_ROUND = 2;

	// Set default value if not defined to 2
	useEffect(() => {
		if (chart.request && chart.request.roundLength === undefined) {
			handleChange("request.roundLength", 2);
		}
	}, [chart, handleChange]);

	return (
		<MDBox
			mt={1}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			className="customSwitchContainer"
			sx={{
				cursor: "default",
				userSelect: "none"
			}}
		>
			<span>{t("CHARTS.roundLength")}</span>
			{/* Choices */}
			<MDBox display="flex" justifyContent="end" alignItems="center">
				{[...Array(MAX_ROUND + 1).keys()].map(i => (
					<MDBox
						key={i}
						sx={{
							border: `1px solid ${colors.grey[300]}`,
							borderRadius: "5px",
							ml: 1,
							px: 1.5,
							cursor: "pointer",
							backgroundColor: chart.request.roundLength === i ? colors.grey[300] : "transparent",
							"&:hover": { backgroundColor: colors.grey[300] }
						}}
						onClick={() => {
							handleChange("request.roundLength", i);
						}}
					>
						<MDTypography variant="body2" sx={{ fontWeight: "bold" }}>
							{i}
						</MDTypography>
					</MDBox>
				))}
			</MDBox>
		</MDBox>
	);
};

export default RoundField;
